import apiRequest from './apiRequest';

type GetNotificationCountResponse = {
  newCount: number;
};

export default async function getNotificationsCount() {
  return apiRequest<GetNotificationCountResponse>('user', '/users/notifications/count');
}
